export default __webpack_public_path__ + "static/media/orangelabel.4d9b97d0.png";